module.exports = __webpack_public_path__ + "static/media/rating.7b9829f7.svg";